import { gql } from 'apollo-boost'

import useMutation, { mutationTypes } from '@utils/graphqlUtils'

const MUTATION = gql`
  mutation(
    $id: String!
    $data: IrrigationTypeUpdateInput!
  ) {
    updateOneIrrigationType(
      where: {
        id: $id
      }
      data: $data
    ) {
      id
    }
  }
`

export default () => (
  useMutation(MUTATION, `Tipo de rega actualizado`, mutationTypes.UPDATE)
)

